module.exports = __webpack_public_path__ + "img/kong.2ae961c0.png";